import { useRef, useEffect } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

/**
 * Textarea que crece automáticamente con el contenido (sin truncar el texto).
 * Reemplaza inputs de una sola línea para descripciones/notas largas de line items.
 * Mantiene visible TODO el texto multilínea y se auto-ajusta al escribir o al
 * cargar contenido existente (ej. al abrir un template/estimado/invoice a editar).
 */
export const AutoGrowTextarea = ({ value, onChange, className, minRows = 1, ...props }) => {
  const ref = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };

  // Auto-ajusta al montar y cada vez que cambia el valor (incluye cambios programáticos).
  useEffect(() => {
    resize();
  }, [value]);

  return (
    <Textarea
      ref={ref}
      value={value}
      onChange={(e) => {
        onChange?.(e);
        resize();
      }}
      rows={minRows}
      className={cn('resize-none overflow-hidden leading-snug', className)}
      style={{ minHeight: '36px' }}
      {...props}
    />
  );
};

export default AutoGrowTextarea;
